export const  GET_CONTENT_TERMS_SUCCESS='contentTermsReducer/GET_CONTENT_TERMS_SUCCESS';
export const  GET_CONTENT_TERMS_REQUEST='contentTermsReducer/GET_CONTENT_TERMS_REQUEST';
export const  GET_CONTENT_TERMS_FAILED='contentTermsReducer/GET_CONTENT_TERMS_FAILED';